import React from "react"
import { get } from "../../../helpers/utils"
import PropTypes from "prop-types"
import * as styles from "./Footer-tw-styles"
import Link from "../../UI/Link/Link"
import MondelezeImage from "../../UI/Image/MondelezeImage"
import { labels } from '../../../constants/label.constants'

const Footer = props => {
  const {
    brandLogo,
    copyRight,
	footerLink,
	language
  } = props


  const style = language?.toLowerCase() == "en" ? styles["ENG_FOOTER_NEW"] : styles.defaultStyle
  const footerLinks = 
    footerLink && get(footerLink.linksCollection, "items", [])
	
  return (
    <div className={style?.FooterWrapper}>
      <div className={style?.footerMain}>

        <div className={style?.footercopyLinkGrp}>
          <div className={style?.footerCookieLinks}>
            {footerLinks?.length > 0 &&
              footerLinks?.map((link, index) => {
				        return (
                  <Link className={style?.footersingleLink} key={link?.id || index} {...link}/>
                )
              })}
              <div className={style?.footerLogotextMobile}>{copyRight}</div>
          </div>
          <div className={style?.FooterCopyright}>
            <Link url={labels?.urls?.international} gaEventLabel={labels?.footer?.footerLogo}>
              <MondelezeImage className={style?.footerLogo} src={brandLogo?.url} />
            </Link>
            <div className={style?.footerLogotext}>{copyRight}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

Footer.propTypes = {
  brandLogo: PropTypes.object,
  copyRight: PropTypes.string,
  footerLink: PropTypes.object,
  language: PropTypes.string
}

export default Footer
